export default __webpack_public_path__ + "static/media/arrow_left.6011d1b4.svg";